import React, { useRef, useState } from "react";
import { SovosBox, SovosPopover, SovosTypography } from "mosaic-react";
import StagingIssueHoverCard from "./StagingIssueHoverCard";

const HOVER_CLOSE_DELAY_MS = 120;

const StagingErrorCell = ({ displayValue }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const closeTimerRef = useRef(null);

    const clearCloseTimer = () => {
        if (closeTimerRef.current) {
            clearTimeout(closeTimerRef.current);
            closeTimerRef.current = null;
        }
    };

    const openPopover = (event) => {
        clearCloseTimer();
        setAnchorEl(event.currentTarget);
    };

    const scheduleClose = () => {
        clearCloseTimer();
        closeTimerRef.current = setTimeout(() => {
            setAnchorEl(null);
        }, HOVER_CLOSE_DELAY_MS);
    };

    return (
        <>
            <SovosBox
                data-staging-error-cell="true"
                onMouseEnter={openPopover}
                onMouseLeave={scheduleClose}
                sx={{ minWidth: 0, width: "100%" }}
            >
                <SovosTypography noWrap sx={{ width: "100%" }} variant="body2">
                    {displayValue ?? ""}
                </SovosTypography>
            </SovosBox>
            <SovosPopover
                anchorEl={anchorEl}
                anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus
                disableScrollLock
                onClose={() => setAnchorEl(null)}
                open={Boolean(anchorEl)}
                slotProps={{
                    paper: {
                        onMouseEnter: clearCloseTimer,
                        onMouseLeave: scheduleClose,
                        sx: {
                            borderRadius: 2,
                            boxShadow: 3,
                            mt: 0.5,
                            overflow: "hidden",
                            pointerEvents: "auto",
                        },
                    },
                }}
                sx={{ pointerEvents: "none" }}
                transformOrigin={{ horizontal: "left", vertical: "top" }}
            >
                <StagingIssueHoverCard />
            </SovosPopover>
        </>
    );
};

export default StagingErrorCell;
